import { useState } from "react";
import { useNavigate } from "react-router-dom";

import { Box, IconButton, IconButtonProps, Tooltip } from "@mui/material";

import { Translator } from "@/components/i18n";

import SquarePenIcon from "@/assets/squarePen";

import NewChatDialog from "./newChatDialog";
import { useChatInteract } from "@/client/useChatInteract";
import { useSetRecoilState } from "recoil";
import { companyState } from "@/client/state";

export default function NewChatButton(props: IconButtonProps) {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  const { clear } = useChatInteract();
  const setCompanyState = useSetRecoilState(companyState);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleConfirm = () => {
    clear();
    setCompanyState(undefined);
    navigate("/");
    handleClose();
  };

  return (
    <Box>
      <Tooltip
        title={<Translator path="components.molecules.newChatButton.newChat" />}
      >
        <IconButton id="new-chat-button" onClick={handleClickOpen} {...props}>
          <SquarePenIcon
            sx={{ height: 20, width: 20, color: "text.primary" }}
          />
        </IconButton>
      </Tooltip>
      <NewChatDialog
        open={open}
        handleClose={handleClose}
        handleConfirm={handleConfirm}
      />
    </Box>
  );
}
